/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Getting_Started_ContentInputs */

const en_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account, build your first resume using our AI-powered builder, and explore the dashboard to discover job matches tailored to your profile.`)
};

const de_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie Ihr Konto, erstellen Sie Ihren ersten Lebenslauf mit unserem KI-gestützten Editor und entdecken Sie passende Stellenangebote auf Ihrem Dashboard.`)
};

const fr_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre compte, construisez votre premier CV avec notre éditeur assisté par IA et explorez le tableau de bord pour découvrir des offres adaptées à votre profil.`)
};

const es_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree su cuenta, construya su primer currículum con nuestro editor impulsado por IA y explore el panel para descubrir ofertas de empleo adaptadas a su perfil.`)
};

const it_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il tuo account, costruisci il tuo primo curriculum con il nostro editor basato su IA e scopri le offerte di lavoro adatte al tuo profilo.`)
};

const nl_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak uw account aan, bouw uw eerste cv met onze AI-editor en ontdek vacatures die bij uw profiel passen.`)
};

const pl_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto, stwórz swoje pierwsze CV za pomocą naszego edytora AI i odkryj oferty pracy dopasowane do Twojego profilu.`)
};

const fi_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tilisi, rakenna ensimmäinen ansioluettelosi tekoälykäyttöisellä editorillamme ja tutustu kojelautaan löytääksesi profiiliisi sopivia työpaikkoja.`)
};

const da_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret din konto, byg dit første CV med vores AI-drevne editor, og udforsk dashboardet for at finde jobmatch tilpasset din profil.`)
};

const sv_help_getting_started_content = /** @type {(inputs: Help_Getting_Started_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ditt konto, bygg ditt första CV med vår AI-drivna editor och utforska instrumentpanelen för att hitta jobbmatchningar anpassade till din profil.`)
};

/**
* | output |
* | --- |
* | "Create your account, build your first resume using our AI-powered builder, and explore the dashboard to discover job matches tailored to your profile." |
*
* @param {Help_Getting_Started_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_getting_started_content = /** @type {((inputs?: Help_Getting_Started_ContentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Getting_Started_ContentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_getting_started_content(inputs)
	if (locale === "fr") return fr_help_getting_started_content(inputs)
	if (locale === "es") return es_help_getting_started_content(inputs)
	if (locale === "it") return it_help_getting_started_content(inputs)
	if (locale === "nl") return nl_help_getting_started_content(inputs)
	if (locale === "pl") return pl_help_getting_started_content(inputs)
	if (locale === "fi") return fi_help_getting_started_content(inputs)
	if (locale === "da") return da_help_getting_started_content(inputs)
	if (locale === "sv") return sv_help_getting_started_content(inputs)
	return en_help_getting_started_content(inputs)
});